// Fired on window when a ticket is opened, answered or read here, so the header's support
// badge (components/AppShell/SupportBadge.jsx) recounts at once instead of at its next poll.
export const SUPPORT_CHANGED_EVENT = "support:changed";
